import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const features = [
  {
    title: "Grow Reviews",
    description:
      "You can collect customer reviews for your business on platforms like Google Reviews, Trustpilot, and Yelp to enhance credibility and attract more customers.",
    image:
      "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50c86073126730375bbc5_Group%201000005174.png",
  },
  {
    title: "Manage Replies",
    description:
      "You can manage review replies either manually or with the assistance of AI for efficiency and consistency.",
    image:
      "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50c86073126730375bbd2_Group%203%20(1).png",
  },
  {
    title: "AI Generated Surveys",
    description:
      "You can create AI-generated surveys to streamline data collection and gain valuable insights for your business.",
    image:
      "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50c86073126730375bbc7_Group%201000005172%20(4).png",
  },
];

function NewFeatureSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <div className="w-full bg-white py-20" ref={ref}>
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-12">
        {/* Left Side */}
        <motion.div
          initial={{ x: -100, opacity: 0 }}
          animate={inView ? { x: 0, opacity: 1 } : {}}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="relative flex-1"
        >
          {/* Vertical Line */}
          <div className="absolute top-0 left-0 h-full w-[2px] bg-gray-200 rounded"></div>
          <div
            className="absolute left-0 w-[2px] bg-[#7f56d9] rounded transition-all duration-500"
            style={{
              top: `${activeIndex * 160}px`, // Adjust based on item height
              height: "60px",
            }}
          ></div>

          <div className="pl-6 space-y-16">
            {features.map((feature, index) => (
              <div
                key={index}
                className={`cursor-pointer`}
                onClick={() => setActiveIndex(index)}
              >
                <h3
                  className={`text-2xl font-semibold mb-2 ${
                    activeIndex === index ? "text-[#4a2aad]" : "text-gray-800"
                  }`}
                >
                  {feature.title}
                </h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            ))}
          </div>
        </motion.div>

        {/* Right Side Image */}
        <motion.div
          initial={{ x: 100, opacity: 0 }}
          animate={inView ? { x: 0, opacity: 1 } : {}}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="flex-1 flex justify-center"
        >
          <div className="bg-[#f9f9fb] p-8 md:w-[540px] h-[480px] rounded-2xl flex items-center justify-center transition-all duration-500">
            <AnimatePresence mode="wait">
              <motion.img
                key={features[activeIndex].image}
                src={features[activeIndex].image}
                alt={features[activeIndex].title}
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.95 }}
                transition={{ duration: 0.5 }}
                className="w-full h-full object-contain"
              />
            </AnimatePresence>
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default NewFeatureSection;
